import React from "react";
import { Badge, Paper, Text } from "@mantine/core";
import { skipToken } from "@reduxjs/toolkit/query";
import { DeckBimViewer } from "@multiconsult-group/multiplacer-ui";
import { useGetMcbimItemsInSpaceQuery, usePostMultiplacerDevicesQuery } from "../../../../openapi";
import { useAppSelector } from "../../../app/hooks";
import { selectSelectedSimilarRoomWithDevices } from "./similarRoomsWithDevicesSelectors";
import {
  selectSimilarRoomWithDevicesViewerCeilingGridPixPaths,
  selectSimilarRoomWithDevicesViewerDevicesArgs,
  selectSimilarRoomWithDevicesViewerMcbimItemsArgs,
  selectSimilarRoomWithDevicesViewerPixPolygons,
  selectSimilarRoomWithDevicesViewerZoomExtentKey,
} from "./similarRoomWithDevicesViewerSelectors";

export const SimilarRoomWithDevicesViewer: React.FC = () => {
  const room = useAppSelector(selectSelectedSimilarRoomWithDevices);
  const rotation = useAppSelector((state) => state.design.rotation);
  const devicesArgs = useAppSelector(selectSimilarRoomWithDevicesViewerDevicesArgs);
  const mcbimItemsArgs = useAppSelector(selectSimilarRoomWithDevicesViewerMcbimItemsArgs);

  const { isFetching: isFetchingDevices } = usePostMultiplacerDevicesQuery(
    devicesArgs ?? skipToken
  );
  const { isFetching: isFetchingMcbimItems } = useGetMcbimItemsInSpaceQuery(
    mcbimItemsArgs ?? skipToken
  );

  const polygons = useAppSelector(selectSimilarRoomWithDevicesViewerPixPolygons);
  const ceilingGridPaths = useAppSelector(selectSimilarRoomWithDevicesViewerCeilingGridPixPaths);
  const zoomExtentKey = useAppSelector(selectSimilarRoomWithDevicesViewerZoomExtentKey);

  if (!room) {
    return (
      <Paper
        bg="gray.0"
        radius="sm"
        p="md"
        h="100%"
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Text size="sm" c="dimmed">
          Velg et rom for å vise geometri
        </Text>
      </Paper>
    );
  }

  return (
    <Paper bg="gray.0" radius="sm" p="sm" h="100%" style={{ minHeight: 0, position: "relative" }}>
      {(isFetchingDevices || isFetchingMcbimItems) && (
        <Badge
          variant="white"
          color="gray"
          style={{ position: "absolute", top: 12, right: 12, zIndex: 2 }}
        >
          Laster geometri
        </Badge>
      )}
      <DeckBimViewer
        flip2dCoordinate={true}
        angle={rotation}
        paths={ceilingGridPaths}
        polygons={polygons}
        zoomExtentKey={zoomExtentKey}
      />
    </Paper>
  );
};
